import * as z from 'zod';
import { readImageSchema } from '../images';

// Reference schema with label field (for dropdowns, selects, lookups)
export const readCompanyRefSchema = z.object({
  id: z.uuid(),
  name: z.string(),
});
export type ReadCompanyRef = z.infer<typeof readCompanyRefSchema>;

// Minimal reference schema (for foreign keys)
export const companyRefSchema = z.object({
  id: z.uuid(),
});
export type CompanyRef = z.infer<typeof companyRefSchema>;

export const companySchema = z.object({
  id: z.uuid(),
  name: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(250, 'Name must not exceed 250 characters'),
  domain: z
    .string('Domain must be a string')
    .max(500, 'Domain URL must not exceed 500 characters')
    .nullable(),
  industry: z
    .string()
    .max(100, 'Industry must not exceed 100 characters')
    .nullable(),
  companySize: z
    .string()
    .max(100, 'Company size must not exceed 100 characters')
    .nullable(),
  countries: z.array(z.string()).nullable(),
  logo: z.object(readImageSchema).nullable(),
  // Greyscale variant of `logo`.
  logoGreyscale: z.object(readImageSchema).nullish(),
  // Dark-theme variant of `logo`.
  logoDark: z.object(readImageSchema).nullish(),
  // Greyscale dark-theme variant of `logo`.
  logoGreyscaleDark: z.object(readImageSchema).nullish(),
  // Brandmark (icon-only) logo variant. Preferred over `logo` when present.
  brandmarkLogo: z.object(readImageSchema).nullish(),
  brandmarkLogoDark: z.object(readImageSchema).nullish(),
  brandmarkLogoGreyscaleDark: z.object(readImageSchema).nullish(),
  // Greyscale variant of `brandmarkLogo`.
  brandmarkLogoGreyscale: z.object(readImageSchema).nullish(),
  enrichmentScore: z.number().min(0).max(100).nullable(),
});

export type Company = z.infer<typeof companySchema>;
